module.exports = __webpack_public_path__ + "static/media/APP_LifeSaver_152x174_4.5eccd664.png";